import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { Notifications } from '@mantine/notifications';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { MantineProvider } from '@/providers/MantineProvider.tsx';
import { persistor, store } from '@/store';

import App from '@/App.tsx';

import { initSentry } from './config/sentry';
import LoadingPage from './pages/common/LoadingPage';
import { initChunkErrorHandler } from './utils/chunkErrorHandler';

import './assets/fonts.css';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/carousel/styles.css';

// Initialize error handlers BEFORE anything else
initChunkErrorHandler();
initSentry();

const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <>
        <Notifications />
        <App />
      </>
    )
  }
]);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <MantineProvider>
      <Provider store={store}>
        <PersistGate loading={<LoadingPage />} persistor={persistor}>
          <RouterProvider router={router} />
        </PersistGate>
      </Provider>
    </MantineProvider>
  </React.StrictMode>
);

// App mounted successfully — clear the flag so future deploys can recover
sessionStorage.removeItem('chunk-reload-attempted');
